import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const easeOut = [0.33, 1, 0.68, 1];

export const Overline = ({ children, className = "" }) => (
  <p className={`uppercase tracking-[0.25em] text-xs font-semibold text-terracotta ${className}`}>
    {children}
  </p>
);

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: easeOut }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px -10% 0px" });
  return (
    <div ref={ref} className="overflow-hidden">
      <motion.div
        className={className}
        initial={{ y: "100%" }}
        animate={inView ? { y: "0%" } : { y: "100%" }}
        transition={{ duration: 0.9, delay, ease: easeOut }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export const ArrowLink = ({ children, onClick, href, dark = false, testId }) => {
  const cls = `group inline-flex items-center gap-3 text-sm font-medium uppercase tracking-[0.18em] transition-colors duration-300 ${
    dark ? "text-cream hover:text-mustard" : "text-ink hover:text-terracotta"
  }`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
    </>
  );
  if (href) {
    return (
      <a href={href} onClick={onClick} className={cls} data-testid={testId}>
        {inner}
      </a>
    );
  }
  return (
    <button onClick={onClick} className={cls} data-testid={testId}>
      {inner}
    </button>
  );
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Diamond = () => (
  <span className="inline-block h-1.5 w-1.5 rotate-45 bg-current opacity-60" aria-hidden="true" />
);
